var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.step == 1)?_c('AuthAgree',{attrs:{"shop_info":_vm.shop_info},on:{"click":_vm.next}}):(_vm.step == 2)?_c('JoinForm',{attrs:{"user":_vm.item},on:{"click":_vm.setItem}}):(_vm.step == 4)?_c('JoinResult',{attrs:{"user":_vm.item}}):(_vm.step == 3)?_c('JoinFalse',{attrs:{"message":_vm.message}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }